import { ContractHonorariumListItemDTO } from '../../../dto/contractHonorarium/ContractHonorariumDTO'

export function describeRow(row: ContractHonorariumListItemDTO): string {
  const isGeneral = (value: string) => !value || value === '(General)'
  const healthEntity = isGeneral(row.healthentityname)
    ? null
    : `${row.healthentityname}${isGeneral(row.healthentityplanname) ? '' : ` (${row.healthentityplanname})`}`
  const parts = [
    isGeneral(row.professional) ? null : row.professional,
    healthEntity,
    isGeneral(row.nomenclator) ? null : row.nomenclator,
    isGeneral(row.buildingname) ? null : row.buildingname,
  ].filter((part): part is string => part !== null)
  return parts.length > 0 ? parts.join(' · ') : 'alcance general'
}
